
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import "./App.css";
import ManagerLayout from "./components/layout/ManagerLayout";
import AuthPage from "./pages/auth/AuthPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import HomePage from "./pages/HomePage";
import ManagerDashboard from "./pages/manager/ManagerDashboard";
import AskFrank from "./pages/manager/AskFrank";
import ProfilePage from "./pages/manager/ProfilePage";
import MemberDocumentsPage from "./pages/manager/MemberDocumentsPage";
import AdminDashboard from "./pages/manager/AdminDashboard";
import ArticlesManagement from "./pages/manager/ArticlesManagement";
import DocumentsPage from "./pages/manager/DocumentsPage";
import OrganizationUsers from "./pages/manager/OrganizationUsers";
import AdminRoute from "./components/manager/AdminRoute";
import FrankManagement from "./pages/manager/FrankManagement";
import { LanguageProvider } from "./contexts/LanguageContext";
import ContactPage from "./pages/ContactPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen">
          <Routes>
            {/* Public routes - NO auth required - Always accessible */}
            <Route path="/" element={<HomePage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            
            {/* Authentication routes - Always public */}
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/login" element={<Navigate to="/auth" replace />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            
            {/* Manager routes with navigation */}
            <Route path="/manager" element={<ManagerLayout />}>
              {/* Default manager route */}
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<ManagerDashboard />} />
              <Route path="ask-frank" element={<AskFrank />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="documents" element={<MemberDocumentsPage />} />
              
              {/* Admin protected routes */}
              <Route element={<AdminRoute />}>
                <Route path="admin" element={<AdminDashboard />} />
                <Route path="articles" element={<ArticlesManagement />} />
                <Route path="admin/documents" element={<DocumentsPage />} />
                <Route path="frank" element={<FrankManagement />} />
                <Route path="organization-users/:organizationName" element={<OrganizationUsers />} />
              </Route>
            </Route>
          </Routes>
        </div>
        <Toaster />
      </Router>
    </LanguageProvider>
  );
}

export default App;
